"use strict";
exports.__esModule = true;
exports["default"] = {
    firstNameInput: '.js-first-name-input',
    lastNameInput: '.js-last-name-input',
    emailInput: '.js-email-input',
    passwordInput: '.js-password-input',
    genderSelect: '.js-gender-select',
    phoneNumberCodeSelect: '.js-phone-number-code-select',
    phoneNumberInput1: '.js-phone-number-input-1',
    phoneNumberInput2: '.js-phone-number-input-2',
    codeInput: '.js-code-input',
    addressInput1: '.js-address-input-1',
    cityInput: '.js-city-input',
    districtInput: '.js-district-input',
    zipInput: '.js-zip-input',
    birthdayDaySelect: '.js-birthday-day-select',
    birthdayMonthSelect: '.js-birthday-month-select',
    receivePromotionCheckbox: '#receive_promotion',
    receiveEmailCheckbox: '#receive_email',
    receiveSmsCheckbox: '#receive_sms',
    termsCheckbox: '#agreeTerms',
    subscribeNewsCheckbox: '#subscribeNews',
    registerSubmitBtn: '.js-register-submit-btn',
    sendCodeBtn: '.js-send-code-btn',
    loadingOverlay: '.js-loading-overlay',
};
